import { defineComponent as _defineComponent } from 'vue';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        var _a;
        const store = useStore();
        const s = 'https://app.chatplus.jp/cp.js';
        document['__cp_d'] = 'https://app.chatplus.jp';
        document['__cp_c'] = store.state.userSettings.language === 'Japanese' ? 'd1302727_4' : 'd1302727_8';
        const a = document.createElement('script');
        const m = document.getElementsByTagName('script')[0];
        a.async = true;
        a.src = s;
        (_a = m.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(a, m);
        // const close = () => {
        //   const chatplus = document.getElementById('chatplusview');
        //   if (chatplus) {
        //     chatplus.hidden = true;
        //     chatplus.style.display = 'none';
        //   }
        // };
        // const setCloseAction = () => {
        //   const hideButton = document.getElementsByClassName('button-hide')[0] as HTMLAnchorElement;
        //   hideButton.onclick = close;
        // };
        // const WAIT_TIME = 2000;
        // setTimeout(setCloseAction, WAIT_TIME);
        return () => { };
    }
});
